// extracted by mini-css-extract-plugin
module.exports = {"component":"ZoneName_component__E9_XZ","zone-name":"ZoneName_zone-name__xuCcE","zone-power-text":"ZoneName_zone-power-text__cKiIm"};